import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, Chip, Typography, CircularProgress, Stack } from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import { getEffectivePermissions, type UserListItem } from '../../api/admin'

/** FR-ADM-028 — ce poate face efectiv un utilizator, rezultat din toate rolurile cumulate. */
export default function EffectivePermissionsDialog({ user, onClose }: { user: UserListItem | null; onClose: () => void }) {
  const { data, isLoading } = useQuery({
    queryKey: ['admin', 'effective-permissions', user?.id],
    queryFn: () => getEffectivePermissions(user!.id),
    enabled: !!user,
  })

  return (
    <Dialog open={!!user} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Permisiuni efective — {user?.firstName} {user?.lastName}</DialogTitle>
      <DialogContent>
        {isLoading ? (
          <Box sx={{ display: 'grid', placeItems: 'center', py: 4 }}><CircularProgress size={28} /></Box>
        ) : data ? (
          <Stack spacing={2}>
            <Box>
              <Typography variant="overline" color="text.secondary">Roluri</Typography>
              <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap', mt: 0.5 }}>
                {data.roles.map((r) => <Chip key={r} label={r} size="small" color="primary" variant="outlined" />)}
              </Box>
            </Box>
            <Box>
              <Typography variant="overline" color="text.secondary">Puncte de lucru</Typography>
              <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap', mt: 0.5 }}>
                {data.workPoints.map((w) => <Chip key={w.id} label={w.name} size="small" variant="outlined" />)}
              </Box>
            </Box>
            <Box>
              <Typography variant="overline" color="text.secondary">
                Permisiuni ({data.permissions.length})
              </Typography>
              <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap', mt: 0.5, maxHeight: 280, overflowY: 'auto' }}>
                {data.permissions.map((p) => (
                  <Chip key={p} label={p} size="small" variant="outlined" sx={{ fontFamily: 'monospace', fontSize: 10.5 }} />
                ))}
              </Box>
            </Box>
          </Stack>
        ) : null}
      </DialogContent>
      <DialogActions><Button onClick={onClose}>Închide</Button></DialogActions>
    </Dialog>
  )
}
